import ItemService from '@/services/ItemService'
import maxPopust from '@/snippets/maxPopust'

// Povezivanje uvezenih stavaka sa sifrarnikom po SIFRI DOBAVLJACA.
//
// Koristi se na dva mjesta: kod uvoza iz Excela i kod "Napravi primku" iz
// eRacuna. Oba su dosad upisivala samo sifru dobavljaca, pa je korisnik svaku
// stavku morao rucno spajati s lokalnom sifrom i rucno upisivati prodajnu
// cijenu - a kod vecih uvoza to je bio glavni posao.
//
// Kad se artikl nadje:
//   - stavka dobiva lokalnu sifru, naziv, mjeru i grupu iz sifrarnika
//   - PRODAJNA cijena se uzima iz sifrarnika (to je cijena koju je firma
//     odredila), a nabavna ostaje ona s primke
//   - marza i max popust se preracunaju iz te dvije cijene
//
// Kad se artikl NE nadje, stavka ostaje tocno kakva je bila: prodajna cijena
// jednaka nabavnoj, bez lokalne sifre. Isto vrijedi kad ista sifra dobavljaca
// vodi na vise artikala - tada se ne pogadja, nego se stavka oznaci.

const broj = (vrijednost) => parseFloat(vrijednost) || 0
const zaokruzi = (vrijednost) => Math.round(broj(vrijednost) * 100) / 100

// Dohvat sifrarnika, jednom za cijeli uvoz.
export async function dohvatiSifrarnik (companyId) {
  try {
    const { data } = await ItemService.bysuppcode({ CompanyId: companyId })
    return {
      artikli: data && data.items ? data.items : {},
      visestruke: data && data.visestruke ? data.visestruke : []
    }
  } catch (greska) {
    // Uvoz ne smije stati zbog sifrarnika; stavke tada ostaju nespojene.
    return { artikli: {}, visestruke: [] }
  }
}

// Dopuni jednu stavku podacima iz sifrarnika. Mijenja stavku na mjestu i vraca
// oznaku sto se dogodilo: 'spojeno' | 'visestruko' | 'nije-nadjeno'.
export function spojiStavku (stavka, sifrarnik) {
  const sifraDob = String(stavka.ItemSuppCode || '').trim()
  if (sifraDob === '') { return 'nije-nadjeno' }

  if (sifrarnik.visestruke.indexOf(sifraDob) !== -1) {
    // Ista sifra dobavljaca na vise artikala - ne pogadjamo koji je pravi.
    return 'visestruko'
  }

  const artikl = sifrarnik.artikli[sifraDob]
  if (!artikl) { return 'nije-nadjeno' }

  const kolicina = broj(stavka.itemPcsPlus)
  const nabavna = broj(stavka.itemSuppPrice)
  const prodajna = broj(artikl.itemPrice)
  // PDV s primke ima prednost: na racunu je stvarna stopa za tu isporuku.
  const pdv = broj(stavka.itemVAT1Percentage) !== 0
    ? broj(stavka.itemVAT1Percentage)
    : broj(artikl.itemVAT1Percentage)

  stavka.itemID = artikl.itemID
  stavka.itemName = artikl.itemName ? artikl.itemName : stavka.itemName
  stavka.itemUnit = artikl.itemUnit ? artikl.itemUnit : stavka.itemUnit
  stavka.itemGroup = artikl.itemGroup ? artikl.itemGroup : stavka.itemGroup
  stavka.itemGroupName = artikl.GroupName ? artikl.GroupName : stavka.itemGroupName
  stavka.itemService = artikl.itemService === true
  stavka.PotpunaSifra = artikl.PotpunaSifra ? artikl.PotpunaSifra : stavka.PotpunaSifra
  // Slika se prepisuje kao i kod rucnog odabira artikla.
  stavka.ItemPicture1 = artikl.ItemPicture1 ? artikl.ItemPicture1 : stavka.ItemPicture1
  stavka.ItemDefaultPicture = artikl.ItemDefaultPicture ? artikl.ItemDefaultPicture : null

  // Prodajna cijena iz sifrarnika; nabavna ostaje s primke.
  stavka.itemPrice = prodajna
  stavka.itemVAT1Percentage = pdv

  const osnovica = zaokruzi(prodajna * kolicina)
  const sPdvom = zaokruzi(osnovica * (1 + pdv / 100))
  stavka.itemBaseAmount = osnovica
  stavka.itemBaseForeAmount = osnovica
  stavka.itemBaseAmountNoVAT = osnovica
  stavka.itemBaseForeAmountNoVAT = osnovica
  stavka.itemVAT1Amount = zaokruzi(sPdvom - osnovica)
  stavka.itemBaseAmountWithVAT = sPdvom
  stavka.itemBaseForeAmountWithVAT = sPdvom
  stavka.itemAmountWithVAT = sPdvom
  stavka.itemFullTotal = sPdvom
  stavka.itemPriceWithVAT = kolicina !== 0 ? zaokruzi(sPdvom / kolicina) : 0

  // Marza se racuna iz stvarne nabavne s primke i prodajne iz sifrarnika.
  const marzaNovcano = zaokruzi(osnovica - broj(stavka.itemSuppPriceAmount))
  stavka.itemMarginAmount = marzaNovcano
  stavka.itemMargin = nabavna !== 0 ? zaokruzi((prodajna - nabavna) / (nabavna / 100)) : 0
  stavka.itemMaxDiscount = maxPopust(prodajna, nabavna)
  stavka.FreeF2 = kolicina !== 0 ? zaokruzi(marzaNovcano / kolicina) : 0

  return 'spojeno'
}

// Prolazak kroz sve stavke; vraca brojke za poruku korisniku.
export function spojiStavke (stavke, sifrarnik) {
  const zbroj = { spojeno: 0, visestruko: 0, nijeNadjeno: 0 }
  stavke.forEach(stavka => {
    const ishod = spojiStavku(stavka, sifrarnik)
    if (ishod === 'spojeno') { zbroj.spojeno += 1 }
    if (ishod === 'visestruko') { zbroj.visestruko += 1 }
    if (ishod === 'nije-nadjeno') { zbroj.nijeNadjeno += 1 }
  })
  return zbroj
}
